import DeletePopUp from "./components/DeletePopUp";
import Pagination from "./Pagination";
import PageLoader from "./PageLoader";
import STableLoader from './skeleton_loader/STableLoader';
import STabsLoader from './skeleton_loader/STabsLoader';
import ExportMenu from './ExportMenu';
import NoRecordFound from "./NoRecordFound";
import PopOverCTACopy from "./components/PopOverCTACopy";
import PopOverCTA from "./components/PopOverCTA";
import PageNotFound from "./components/PageNotFound";
import FilterComponent from "./components/FilterComponent";
import { getGlobalCookie } from "../utils";

const userInfo=JSON.parse(getGlobalCookie('lessorAccess'));
const leshaBankInstance=[510].includes(userInfo?.id);
const titanAviationIntance = [480].includes(userInfo?.id);
const MTAviationInstance=[519].includes(userInfo?.id);
const jetstreamAvi = [442].includes(userInfo?.id);
const jetStreamInstance = [442].includes(userInfo?.id);
const avationPlcInstance =  [504].includes(userInfo?.id);
const gaTelesisInstance = [498].includes(userInfo?.id);
const castleAirInstance = [479,472].includes(userInfo?.id);
const halcyonInstance = [484].includes(userInfo?.id);
const smbcInstance = [465].includes(userInfo?.id);
const lessorCheckInstance =  [406].includes(userInfo?.id) ;
const titanAviInstance =  userInfo?.id === 480;
const hanwahaInstance = [483].includes(userInfo?.id);
const regionalOneInstance = [242].includes(userInfo?.id);
const mtInstance = [213].includes(userInfo?.id);
const wngCapitalInstance =  [213].includes(userInfo?.id);
const testLessor = [13].includes(userInfo?.id);
const spartaLease = [321].includes(userInfo?.id);

export { DeletePopUp, Pagination, PageLoader, STableLoader, STabsLoader, ExportMenu, NoRecordFound, PopOverCTACopy, PopOverCTA, PageNotFound, FilterComponent, leshaBankInstance, titanAviationIntance, MTAviationInstance, jetstreamAvi, jetStreamInstance,avationPlcInstance, gaTelesisInstance, castleAirInstance, halcyonInstance, smbcInstance, lessorCheckInstance, titanAviInstance, hanwahaInstance, regionalOneInstance, mtInstance, wngCapitalInstance, testLessor, spartaLease};


